import React, { useState } from 'react'
import { createFormBag, FormBag, FormData, FormErrors, FormUpdateEvent, validateFormBag } from 'react-formage'
import { Button, ButtonGroup } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { Modal } from 'components/ui/modal'
import { StatusGuard } from 'components/ui/status-guard'

import { Status } from 'helpers/status'
import { categorySchema } from '../../../schemas/category'
import { TranslatableStringValue } from 'generated/mos/translatable'
import { TourCategory } from 'generated/mos/org/getty/audio'


type Props = {
  readonly onClose: () => void;
  readonly category: TourCategory.Entity;
  readonly onSubmit: (categoryRef: TourCategory.Ref, name: TranslatableStringValue.Entity ) => void;
}

type FormValues = {
  readonly categoryName: string;
}

export const CategoryUpdate = (props: Props) => {
  const {
    onClose,
    category,
    onSubmit,
  } = props

  const categoryName = categorySchema.name.read(category.name) as string
  const bag: FormBag<FormValues> = createFormBag({
    categoryName,
  })
  const [ formBag, setFormBag ] = useState(bag)

  const onFormUpdate = (event: FormUpdateEvent<FormValues>) => {
    setFormBag(event.bag)
  }

  const onFormValidate = (values: FormValues) => {
    const errors: FormErrors<FormValues> = {}
    return errors
  }

  const save = () => {
    const bag = validateFormBag(formBag, onFormValidate)
    setFormBag(bag)

    if (!bag.valid) {
      return
    }
    const { category } = props
    const { categoryName } = bag.values
    if(categoryName && category.ref) {
      onSubmit(category.ref, categorySchema.name.write(categoryName, category.name))
      onClose()
    }
  }

  const { errors, touched, values } = formBag

  const footer = (
    <ButtonGroup>
      <Button
        type="button"
        key="cancel"
        appearance="secondary"
        onClick={(event) => { event.preventDefault(); onClose(); }}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        isDisabled={!values.categoryName.length }
        onClick={() => save()}
      >
        Update
      </Button>
    </ButtonGroup>
  )

  return (
    <Modal onClose={onClose} header={<h3>Update category</h3>} footer={footer}>
      <form noValidate onSubmit={(event) => { event.preventDefault(); save(); }}>
        <StatusGuard status={{ status: Status.Idle }} mode="form">
          <FormData
            bag={formBag}
            onUpdate={onFormUpdate}
            validate={onFormValidate}
          >
            <Input
              label="Category name"
              field="categoryName"
              error={touched.categoryName ? errors.categoryName : undefined}
            />
          </FormData>
        </StatusGuard>
      </form>
    </Modal>
  )
}
